import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { Warehouse, WarehouseCreate, WarehouseFilter } from '../data/warehouse';

export function createWarehouseService(client: AxiosInstance) {
  return createCrudService<Warehouse, WarehouseCreate, WarehouseFilter>(client, '/Warehouse', 'warehouseId');
}

export type WarehouseService = CrudService<Warehouse, WarehouseCreate, WarehouseFilter>;
